import React, {Component} from 'react';
import PropTypes from "prop-types";

export default class InputContainer extends Component {
  static propTypes = {
    unit: PropTypes.string,
  };

  static defaultProps = {
    onFocus: () => {},
    max: Infinity,
  };

  constructor(props) {
    super(props);
    this.setValue = this.setValue.bind(this);
    this.sendToParent = this.sendToParent.bind(this);
  }

  setValue(event) {
    let val;
    if (event.target !== undefined) {
      val = parseInt(event.target.value, 10);
    } else {
      val = parseInt(event, 10);
    }
    if (val > this.props.max) {
      event.target.value = this.props.max;
      val = this.props.max;
    }
    if (val >= this.props.min) {
      this.setState({value: val});
    } else {
      this.setState({value: this.props.min});
    }
    this.sendToParent(val);
  }

  sendToParent(val) {
    if (this.props.customOnChange) {
      this.props.customOnChange(this.props.onChangeKey, val);
    }
  }

  render() {
    return (
      <div className={'slider-container input'}>
        <p>{this.props.title}</p>

        <input
          max={this.props.max}
          onFocus={this.props.onFocus}
          type={this.props.disabled ? (this.props.value === 0 ? 'text' : 'number') : 'number'}
          onChange={this.setValue.bind(this)}
          value={this.props.disabled ? (this.props.value === 0 ? '-' : this.props.value) : this.props.value || 0}
          className={(this.props.disabled ? 'disabled value-container' : 'value-container') + (this.props.role === 'groupmember' ? ' groupmember-disabled' : '')}/>

        { this.props.unit ? <span className={(this.props.role === 'groupmember' ? ' groupmember-disabled' : '')} title={this.props.unit}>{this.props.unit}</span> : null }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/StepThree/InputContainer.js